import devices from "./devices"

const theme = {
  devices: {
    ...devices,
  },
}

export default theme
